class Calendar {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    $('.js-modal-trigger').click(function() {
      $('.js-modal').css({'opacity': '1', 'pointer-events': 'inherit'});
      $('.js-modal-date').text($(this).data('date'));
      $('.js-modal-txt').text($(this).data('txt'));
    })

    $('[data-class="js-modal-close"]').click(function() {
      $('.js-modal').css({'opacity': '0', 'pointer-events': 'none'});
    })

    let date = new Date();
    let swiper = new Swiper(".calendarSwiper", {
      initialSlide: $(`[data-year="${date.getFullYear()}"][data-month="${date.getMonth() + 1}"]`).index(),
      allowTouchMove: false,
      speed: 600,
      spaceBetween: 40,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
}
class Contact {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    // 講習時間目安 パラメータ引き渡し
    const searchParams = new URLSearchParams( window.location.search );

    $("[name='講習時間目安']").attr('value', searchParams.get('send'));

    // ラジオボタン　選択によるコンテンツ切り替え
    const radioBtns = document.querySelectorAll(".js-contact-radio")
    const selectedContent = document.querySelectorAll(".js-contact-content ")

    let  hiddenValue = document.getElementsByName("sendmail")[0]


    const mail01 = document.querySelector(".js-mail-01")
    const mail02 = document.querySelector(".js-mail-02")


    radioBtns.forEach((btn, i) => {

      if(btn.checked){

        if(btn.value === "講習のご予約"){
          selectedContent[0].classList.add("is-active")
          selectedContent[1].classList.remove("is-active")
        }else if(btn.value === "ご質問"){
          selectedContent[0].classList.remove("is-active")
          selectedContent[1].classList.add("is-active")
        }else{
          console.log("該当のものはありません");
        }
      }

      btn.addEventListener("click", () => {

        selectedContent.forEach(content => {

          //表示リセット
          content.classList.remove("is-active")
        })

        selectedContent[i].classList.add("is-active")

      })

    })

    // 入力画面

    const inputPage  = document.querySelector(".mw_wp_form_input")

    if(inputPage){
      mail01.addEventListener("change", (e) => {
        hiddenValue.setAttribute("value",e.target.value)
      })
      mail02.addEventListener("change", (e) => {
        hiddenValue.setAttribute("value",e.target.value)
      })
    }



    // 確認画面の表示出し分け
    const confirmRadio = document.querySelector(".mw_wp_form_confirm .radio_btn")
    if(confirmRadio){
      const confirmRadioText = confirmRadio.textContent.trim()

      selectedContent.forEach(content => {
        content.classList.remove("is-active")
      })
      if(confirmRadioText === "講習のご予約"){
        selectedContent[0].classList.add("is-active")
        selectedContent[1].innerHTML = ""
        console.log("講習のご案内");
      }else if(confirmRadioText === "ご質問"){
        selectedContent[0].innerHTML = ""
        selectedContent[1].classList.add("is-active")
        console.log("ご質問");
      }else{
        console.log("該当のものはありません");
      }
    }


    //チェクボックス単一選択
    $.each($('.check_btn'), function(index, value) {
      $(`.check_btn-0${index + 1} .check_btn_item`).on('click', function() {
        if ($(this).prop('checked')){
          // 一旦全てをクリアして再チェックする
          $(`.check_btn-0${index + 1} .check_btn_item`).prop('checked', false);
          $(this).prop('checked', true);
        }
      });
    })
  }
}
class Estimated {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    let functions = this;

    let estimatedTime = [];
    let contactResult = [];

    const tmp_path = $('body').data('path');

    $.ajax({
      url: `${tmp_path}/lib/estimated.json`,
      type: 'GET',
      dataType: "json",
    }).done(function (data) {

      functions.summary(data, 0, data['item'].length, estimatedTime, contactResult);

    }).fail(function (data) {
      // error
      console.log('error');
    });
  }

  summary(data, index, length, estimatedTime, contactResult) {
    let progress = Math.floor(100 * index / length);
    let order;
    let fadeSpeed = 300;
    let functions = this;
    let result = data['item'][index];
    let text = this.text(result);
    let radio = this.radio(result);
    let btn = this.btn(result);

    this.imgRandom();

    if(index === 0) {
      $('.js-back').css({display: 'none'});
    } else {
      $('.js-back').css({display: 'inline-flex'});
    }
    
    $('.js-progress hr').animate({width: progress + '%'});
    $('.js-progress p').text(progress + '%');

    $('.js-content').empty();
    $('.js-content').append(text, radio, btn);

    $('.js-content').attr('data-step', index);

    $('.js-back').off();

    if(radio) {
      $('.js-btn-next').css({opacity: '0.3', pointerEvents: 'none'});

      $('.js-radio').change(function() {
        $('.js-btn-next').css({opacity: '1', pointerEvents: 'inherit'});
        $('.js-btn-next').data('time', $(this).data('time'));
        $('.js-btn-next').data('text', $(this).data('text'));
      });
    }

    $('.js-btn-next, .js-back').click(function() {

      if($(this).hasClass('js-btn-next')) {
        order = 1;
        contactResult.push($(".js-q_text").text() + " : " + $(this).data('text'))
        estimatedTime.push($(this).data('time'));
      } else {
        order = -1;
        contactResult.pop();
        estimatedTime.pop();
      }

      if(data['item'][index + order]) {
        $('.js-content, .js-img').animate({opacity: 0}, fadeSpeed);
      } else {
        $('.js-progress hr').animate({width: '100%'});
        $('.js-progress p').text('100%');
        $('.js-content, .js-img, .js-progress, .js-back').animate({opacity: 0}, fadeSpeed);
      }

      setTimeout(() => {
        $('.js-content').empty();
        functions.judge(data, index + order, length, estimatedTime, contactResult, functions, fadeSpeed);
        $('.js-content, .js-img').animate({opacity: 1}, fadeSpeed);
      }, fadeSpeed);
    })
  }

  judge(data, index, length, estimatedTime, contactResult, functions, fadeSpeed) {
    let result = data['item'][index];
    let result_before = data['item'][index - 1];
    let text,btn;
    if(result) {
      text = this.text(result);
      btn = this.btn(result);
    }

    let total = estimatedTime.reduce(function(sum, element){
      return Math.round(sum + element);
    }, 0);

    this.imgRandom();

    if(result_before && result_before['interruption'] && total == '0') {
      functions.result(data, estimatedTime, contactResult, fadeSpeed, functions);
    } else if(text && btn) {
      functions.summary(data, index, length, estimatedTime, contactResult);
    } else {
      functions.result(data, estimatedTime, contactResult, fadeSpeed, functions);
    }
  }

  result(data, estimatedTime, contactResult, fadeSpeed, functions) {
    let result = data.result;

    let resultText, contactResultJoin;
    
    let total = estimatedTime.reduce(function(sum, element){
      return Math.round(sum + element);
    }, 0);

    contactResultJoin = contactResult.join(',');

    result.forEach(function(el, index) {
      let startTime = result[index].startTime;
      let endTime = result[index].endTime;
      let text = result[index].text;

      if(total >= startTime && total <= endTime) {
        let result_time;
        if(total == 0) {
          result_time = '0時限';
        } else {
          result_time = (Number(total)) + "〜" + (Number(total) + 2) + "時限";
        }
        resultText = $(`
          <div style="opacity: 0;">
            <h3 class="result_ttl">あなたの講習目安時間はこちらです！</h3>
            <p class="result_time">${result_time}</p>
            <div class="result_text"><div>${text}</div></div>
            <a href="${$('body').data('home')}?send=講習時間目安 : ${result_time},${contactResultJoin}" class="c-btn-push result_btn js-btn-result">お申し込み／お問い合わせ</a>
          </div>
        `)
      }
    });

    $('.js-result').empty();
    $('.js-result').append(resultText);
    $('.js-result > *, .js-img').animate({opacity: 1}, fadeSpeed);
  }

  imgRandom() {
    let imgRandom = 0;
    while(true){
      imgRandom = Math.floor(Math.random() * 4) + 1;
      if($(".js-img").data('num') != imgRandom) {
        break;
      }
    }
    let imgsrc = $(".js-img").data('src').replace('$', imgRandom);

    $(".js-img").attr('data-num', imgRandom);
    $(".js-img").attr('src', imgsrc);
  }

  text(result) {
    if(result['text']) {
      return $(`
        <p class="q_text js-q_text">${result['text']}</p>
      `)
    }
  }

  radio(result) {
    let radio;
    if(result['radio']) {
      radio = $(`
        <ul class="radio_btn">
        </ul>
      `)
      let radio_el;
      result['radio'].forEach(el => {
        const radio_el = `
          <li class="${el['class']}">
            <label>
              <input type="radio" name="radio" class="radio_btn_item js-radio" data-time="${el['time']}" data-text="${el['text']}">
              <span>
                ${el['text']}
              </span>
            </label>
          </li>
        `;
        radio.append(radio_el);
      });
    }
    return radio;
  }

  btn(result) {
    let btn;
    if(result['btn']) {
      btn = $(`
        <div class="btn_wrap">
        </div>
      `)
      let btn_el;
      result['btn'].forEach(el => {
        const btn_el = `
          <button data-time="${el['time']}" data-text="${el['text']}" class="c-btn-push js-btn-next">${el['text']}</button>
        `;
        btn.append(btn_el);
      });
    }
    return btn;
  }
}
// globals
const e_root = document.querySelector(':root');

window.addEventListener('load', () => {
  e_root.style.setProperty('--firstViewHeight', `${window.innerHeight}px`);
  e_root.style.setProperty('--vw', `${window.innerWidth}px`);
})

window.addEventListener('resize', () => {
  e_root.style.setProperty('--vw', `${window.innerWidth}px`);
})
class Parts {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const swiper = new Swiper('.js-c-p-slider', {
      loop: true, // ループ有効
      slidesPerView: "auto", // 一度に表示する枚数
      speed: 6000, // ループの時間
      allowTouchMove: false, // スワイプ無効
      autoplay: {
        delay: 0, // 途切れなくループ
      },
    })

  }
}
class Voice {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    const modalTrigger = document.querySelectorAll(".js-voice-modal")
    const modalContainer = document.querySelector(".js-voice-modal-container")
    const modalOverlay = document.querySelector(".js-voice-modal-overlay")
    const modalClose = document.querySelector(".modal-close")

    //モーダル要素
    const modalImgPath = document.querySelector(".js-modal-imgPath")
    const modalTime = document.querySelector(".js-modal-time")
    const modalInfo01 = document.querySelector(".js-modal-info01")
    const modalInfo02 = document.querySelector(".js-modal-info02")
    const modalPaper = document.querySelector(".js-modal-paper")
    const modalCourse = document.querySelector(".js-modal-course")
    const modalVoice = document.querySelector(".js-modal-voice")
    const body = document.querySelector("body")



    modalTrigger.forEach(trigger => {

      trigger.addEventListener("click", () => {

        const imgPath = trigger.querySelector("img").getAttribute('src');

        modalImgPath.setAttribute('src', imgPath);
        modalTime.textContent = trigger.querySelector(".js-time").textContent
        modalInfo01.textContent = trigger.querySelector(".js-info01").textContent
        modalInfo02.textContent = trigger.querySelector(".js-info02").textContent
        modalPaper.textContent = trigger.querySelector(".js-paper").textContent
        modalCourse.textContent = trigger.querySelector(".js-course").textContent
        modalVoice.textContent = trigger.querySelector(".js-voice").textContent

        body.classList.add("no_scroll")

        modalContainer.classList.add("is-active")
        modalOverlay.classList.add("is-active")

      })

    })

    if(modalClose){
      modalClose.addEventListener("click", () => {
        modalContainer.classList.remove("is-active")
        modalOverlay.classList.remove("is-active")
        body.classList.remove("no_scroll")
      })
    }

    modalOverlay.addEventListener("click", () => {
      modalContainer.classList.remove("is-active")
      modalOverlay.classList.remove("is-active")
      body.classList.remove("no_scroll")
    })


  }
}
var CFL = {
  UA: {
    raw: function raw() {
      return navigator.userAgent;
    },
    is: function is(_is) {
      var ua = CFL.UA.raw();
      if (_is === 'issp') {
        return CFL.UA.isSp();
      }
    },
    isSp: function isSp() {
      var ua = CFL.UA.raw();
      return ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0;
    },
    isTablet: function() {
      var ua = CFL.UA.raw();
      if(ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
      } else if (ua.indexOf('iPad') > -1
         || (ua.indexOf('Macintosh') > -1 && CFL.UA.Device.isTouch() )
         || ua.indexOf('Android') > 0) {
        return true;
      }

      return false;
    },
    isEdge: function() {
      return this.raw().indexOf('Edge') != -1;
    },
    isIE: function() {
      var ua = CFL.UA.raw();
      return this.raw().indexOf('Trident') != -1 ;
    }
  },
  Device: {
    isTouch: function() {
      return 'ontouchend' in document;
    }
  }
};

var isMobile = function () {
  return (window.matchMedia('(max-width: '+ APP.bp.mobile +'px)').matches)
}

var isPortrait = function() {
  let defaultOrientation = null;
  if('orientation' in window) {
    var o1 = (window.innerWidth < window.innerHeight);
    var o2 = (window.orientation % 180 == 0);
    defaultOrientation = (o1 && o2) || !(o1 || o2);
  }
  if('orientation' in window) {
    // defaultOrientationがtrueの場合、window.orientationが0か180の時は縦
    // defaultOrientationがfalseの場合、window.orientationが-90か90の時は横
    var o = (window.orientation % 180 == 0);
    if((o && defaultOrientation) || !(o || defaultOrientation)) {
      return true;
    } else {
      return false;
    }
  }
}
class Accordion {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $("." + this.el).parent().parent().parent().next().addClass('c-accordion__inner').css({'display': 'none'});
    $("." + this.el).parent().parent().parent().parent().addClass('c-accordion__wrap')

    $("." + this.el).on('click', function() {
      $(this).toggleClass('is-active');
      $(this).parent().parent().parent().next().slideToggle();
    })
  }
}
class Editor {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.c-editor p, .c-editor div').each(function(index, el) {
      if(el.textContent == ' ' || el.textContent == '') {
        el.style.height = '1px';
        el.style.marginTop = '1.5rem';
      }
    })
  }
}
class Loading {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const body = document.getElementsByTagName('body')[0];
    const btn = document.getElementById('btn');
    let scrollTop = 0;
    
    scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('no_scroll');
    
    setTimeout(() => {
      $(".c-loading").fadeOut(500);
      body.style.top = '';
      body.classList.remove('no_scroll');
      window.scrollTo(0, scrollTop);
    }, 800);
  }
}
class Modal {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.c-modal-inner').parent().clone().insertBefore('.c-modal .c-modal-clone');

    $('main .c-modal-inner').parent().remove();

    const body = document.getElementsByTagName('body')[0];
    let scrollTop = 0;

    $(".c-modal-inner").parent().addClass('u-mt-0');

    $(".c-modal-trigger").on("click", function() {
      $(`#${$(this).data('id')}, .c-modal-overlay`).addClass('is-active');

      scrollTop = window.scrollY;
      body.style.top = (scrollTop * -1) + 'px';
      body.classList.add('no_scroll');

      return false;
    })

    $(".c-modal-close, .c-modal-overlay").on("click", function() {
      $(`.c-modal-inner, .c-modal-overlay`).removeClass('is-active');
      body.style.top = '';
      body.classList.remove('no_scroll');
      window.scrollTo(0, scrollTop);
    })
  }
}
class Slider {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const swiper = new Swiper('.c-swiper', {
      speed: 500,
      loop: true,
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    })
  }
}

class Tab {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.c-tab-trigger').parent().parent().parent().addClass('u-mb-0');
    $(".c-tab-inner").parent().addClass('c-tab-wrap');
    $(".c-tab-wrap").eq(0).css({'display': 'block'});

    $(".c-tab-trigger li").on('click', function() {
      let el_num = $(this).index();
      $(".c-tab-trigger li").removeClass('is-active');
      $(this).addClass('is-active');

      $('.c-tab-wrap').css({'display': 'none'});
      $('.c-tab-wrap').eq(el_num).css({'display': 'block'});
    })
  }
}
//noScroll
class Common {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // let elFs;

    // $('.c-content *').each(function() {

    //   let css = ['font-size', 'padding-left', 'padding-top', 'padding-right', 'padding-bottom', 'margin-left', 'margin-top', 'margin-right', 'margin-bottom']
    //   let this_el = $(this);

    //   css.forEach(el => {
    //     elFs = this_el.css(el);
    //     if(elFs.match(/([0-9]*)\.[0-9]*(px)/)) {
    //       elFs = elFs.replace(/([0-9]*)\.[0-9]*(px)/, '$1$2');          
    //     }
    //     elFs = elFs.replace(/([0-9])px/, '.$1rem');
    //     this_el.css(el, elFs);
    //   });

    //   // height
    //   if($(this).prop('nodeName').match(/TABLE|TD|TR|TBODY/)) {
    //     elFs = $(this).css('height');
    //     if(elFs.match(/([0-9]*)\.[0-9]*(px)/)) {
    //       elFs = elFs.replace(/([0-9]*)\.[0-9]*(px)/, '$1$2');          
    //     }
    //     elFs = elFs.replace(/([0-9])px/, '.$1rem');
    //     $(this).css('height', elFs);
    //   }
    // })  

    // $('.c-content p').each(function() {
    //   if($(this)[0].innerHTML == '&nbsp;') {
    //     $(this)[0].innerHTML = '';
    //   }
    // });
  }
}
// 参考サイト
// https://hacknote.jp/archives/15289/

var cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
class HeaderNav {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // スマホナビ開閉
    const navToggle = '.js-header-nav-toggle';
    const spNav = '.js-sp-nav';
    $(navToggle).on('click',function(){
      $('body').toggleClass("no_scroll")
      $(spNav).slideToggle();
      $(this).toggleClass('is-active');
    })
  }
}

class HomeFunSwiper {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const swiper = new Swiper('.js-home-fun-swiper', {
      speed: 10000,
      loop: true,
      slidesPerView: 1.5,
      spaceBetween: 10,
      autoplay: {
        delay: 0,  
      },
      breakpoints: {
        768: {
          speed: 10000,
          slidesPerView: 2.5,
          spaceBetween: 20,
        }
      },
    })
    const textSwiper = new Swiper('.js-home-fun-text-swiper', {
      speed: 15000,
      loop: true,
      slidesPerView: 1,
      spaceBetween: 20,
      autoplay: {
        delay: 0,  
      },
      breakpoints: {
        768: {
          slidesPerView: 1.5,
        }
      },
    })
  }
}

class HomeGlobalNav {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    // クローンしたい要素を選択（例：IDが'myElement'の要素）
    var elementToClone = document.querySelector('.js-pc-nav');

    // 要素をクローン（子要素も含む）
    var clonedElement = elementToClone.cloneNode(true);

    // クローンした要素に'is-clone'クラスを追加
    clonedElement.classList.add('is-clone');

    // クローンした要素の中の'.js-pc-nav-toggle'要素を選択
    var toggleElement = clonedElement.querySelector('.js-pc-nav-toggle');

    // クリックイベントリスナーを追加
    toggleElement.addEventListener('click', function() {
        clonedElement.classList.toggle('is-active');
      });
    //　スクロールしたら閉じる
      window.addEventListener("scroll", () => {
      clonedElement.classList.remove('is-active');
    })

    // フッター要素を選択（例：タグ名が'footer'の最初の要素）
    var footer = document.getElementsByTagName('footer')[0];

    // クローンした要素をフッターの前に挿入
    footer.parentNode.insertBefore(clonedElement, footer);

    // ScrollTriggerを設定
    ScrollTrigger.create({
      trigger: '.js-home-mv',
      start: 'bottom top', // '.js-home-mv'が画面の下部を通過した時,
      onLeaveBack: () => clonedElement.classList.remove('is-show','is-active'), // 画面から見えなくなった時
      onEnter: () => clonedElement.classList.add('is-show'),   // 画面に再度表示された時
    });
    ScrollTrigger.create({
      trigger: '.top-footer',
      start: 'top', // '.js-home-mv'が画面の下部を通過した時,
      onLeaveBack:  () => clonedElement.classList.add('is-show'), // 画面から見えなくなった時
      onEnter:() => clonedElement.classList.remove('is-show','is-active'),   // 画面に再度表示された時
      // markers:true
    });



  }
}

class HomeInstaSwiper {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const swiper = new Swiper('.js-home-insta-swiper', {
      speed: 35000,
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 0,
      loopedSlides: 5,
      autoplay: {
        delay: 0,
      },
    })
  }
}

class HomeMvSwiper {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const swiper = new Swiper('.js-mv-swiper', {
      speed: 500,
      loop: true,
      effect: 'fade',
      autoplay: {
        delay: 5000,  
      },
    })
  }
}

class HomeTopBack {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    if (window.matchMedia('(max-width: 768px)').matches) {
      // ウィンドウサイズ768px以下のときの処理
      const btn = document.querySelector(".js-top-back");

      btn.addEventListener("click", () => {
        window.scroll({
          top: 0,
          behavior: "smooth",
        });
      });
    }

  }
}

class HomeVoiceSwiper {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const swiper = new Swiper('.js-home-voice-swiper', {
      speed: 500,
      loop: true,
      slidesPerView: 1.2,
      spaceBetween: 12,
      centeredSlides: true,
      autoplay: {
        delay: 5000,
      },
      pagination: {
        el: '.home-voice-swiper-pagination',
        clickable: true, // クリック可能にする
      },
      navigation: {
        nextEl: '.home-voice-swiper-button-next',
        prevEl: '.home-voice-swiper-button-prev',
      },
      breakpoints: {
        768: {
          speed: 500,
          slidesPerView: 2,
          spaceBetween: 20,
        }
      },
    })
  }
}

//noScroll
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    this.para_ele = document.querySelectorAll("." + this.el);
    this.para_ele.forEach((ele, index)=> {
      if(ele.classList.contains('js-parallax--reverse')) {
        this.translateY = '20px';
      } else {
        this.translateY = '-20px';
      }
      ele.classList.add(this.el + index);
      gsap.to('.' + this.el + index + ' img', {
        translateY: this.translateY,
        scrollTrigger: {
          trigger: '.' + this.el + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          scrub: 3,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt){
    this.el = el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

class IssueList {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    let zIndex = 1;
    $(document).ready(function () {
        var items = $('.js-issue-list li');
        var started = false;

        gsap.registerPlugin(ScrollTrigger);

        function startAnimation() {
            if (started) return;
            started = true;

            // 最初の3つの要素にis-activeクラスを付与
            for (var i = 0; i < 2; i++) {
                items.eq(i).addClass('is-active');
            }

            // 3秒後に最初の3つの要素からis-activeクラスを1秒ごとに削除
            var windowWidth = $(window).width();
            var intervalTime = windowWidth <= 768 ? 3000 : 4000;
            for (var i = 0; i < 3; i++) {
                (function (index) {
                    setTimeout(function () {
                        items.eq(index).removeClass('is-active');
                    }, intervalTime + 2000 * index);
                })(i);
            }

            setInterval(function () {
                addRandomActiveClass();
            }, 1500);
        }

        ScrollTrigger.create({
            trigger: ".js-issue-list",
            start: "top bottom", // 要素が画面の下端に達したときにトリガー
            onEnter: startAnimation
        });

      // ランダムに要素にis-activeクラスを追加し、3秒後に削除する関数
      function addRandomActiveClass() {
            zIndex++;
            var windowWidth = $(window).width();
            var dataAttribute = windowWidth <= 768 ? 'data-overlap-mobile' : 'data-overlap-pc';
            var removeClassTime = windowWidth <= 768 ? 5000 : 8000;

            var activeOverlap = $('.js-issue-list li.is-active').map(function () {
                var overlapData = $(this).attr(dataAttribute);
                return overlapData ? overlapData.split(',') : [];
            }).get().flat();

            activeOverlap = [...new Set(activeOverlap)];

            var nonActiveItems = items.filter(function () {
                var itemOverlap = $(this).attr(dataAttribute);
                itemOverlap = itemOverlap ? itemOverlap.split(',') : [];
                return !$(this).hasClass('is-active') && !itemOverlap.some(r => activeOverlap.includes(r));
            });

            if (nonActiveItems.length > 0) {
                var randomIndex = Math.floor(Math.random() * nonActiveItems.length);
                var selectedItem = nonActiveItems.eq(randomIndex).css({'z-index': zIndex}).addClass('is-active');

                setTimeout(function () {
                    selectedItem.removeClass('is-active');
                }, removeClassTime);
            }
        }
    });
  }
}

class ModalScroll {
  constructor(el, opt) {
    this.el = el;
    this.event();
  }
  event() {
    const scrollBtn = $(".c-modal-close, .js-voice-modal-overlay, .js-voice-modal-close");
    const scrollInner = $(".modal-inner");

    // スクロールして上に戻る
    scrollBtn.on('click', function (e) {
      setTimeout(function(){
        e.preventDefault();
        scrollInner.animate({ scrollTop: 0 }, 100);
      },200);
    });
  }
}
class SmoothScroll {
  constructor(el, opt) {
    this.el = el;
    this.event();
  }
  event() {

    const urlHash = location.hash;
    if(urlHash) {
      $('body,html').stop().scrollTop(0);
      setTimeout(function(){
        const target = $(urlHash);
        const position = target.offset().top + -30;
        $('body,html').stop().animate({scrollTop:position}, 500);
      }, 100);
    }
    $('a[href^="#"]').click(function(){
      const href= $(this).attr("href");
      const target = $(href);
      const position = target.offset().top + -30;
      $('body,html').stop().animate({scrollTop:position}, 500);
      return false;
    });
  }
}



(() => {

})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {

  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {
  let common = new Common('c-content');
  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('.js-inview');
  let headerNav = new HeaderNav('js-header');
  let homeMvSwiper = new HomeMvSwiper('js-mv-swiper');
  let homeFunSwiper = new HomeFunSwiper('js-home-fun-swiper');
  let homeVoiceSwiper = new HomeVoiceSwiper('js-home-voice-swiper');
  let homeInstaSwiper = new HomeInstaSwiper('js-home-insta-swiper');
  let homeGlobalNav = new HomeGlobalNav('js-pc-nav');
  let homeTopBack = new HomeTopBack('js-top-back');
  let issueList = new IssueList('js-issue-list');
  let parts = new Parts('p-parts');
  let voice = new Voice('js-aVoice');
  let calendar = new Calendar('p-calendar');
  let contact = new Contact('p-contact');
  let estimated = new Estimated('p-estimated');
  let smoothScroll = new SmoothScroll('');
  let modalScroll = new ModalScroll('js-modal-scroll');

  // 以下ページビルダー用
  let accordion = new Accordion('c-accordion');
  let modal = new Modal('c-modal-trigger');
  let tab = new Tab('c-tab-trigger');
  let swiper = new Slider('c-swiper');
  let loading = new Loading('c-loading');
  let editor = new Editor('c-editor');
});

// スマホ・タブレットの向き判定
// $(window).on('orientationchange', ()=>{
//   if(isPortrait()){
//     console.log('isPortrait');
//   } else {
//     console.log('isLandscape');
//   }
// });